import React, { createContext, useState, useContext } from 'react';
import { validateUser, registerUser } from '../api/mockData'; // 导入验证和注册函数

const AuthContext = createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem('user');
    return savedUser ? JSON.parse(savedUser) : null;
  });

  const login = (username, password) => {
    return validateUser(username, password)
      .then(validUser => {
        if (validUser) {
          // 登录成功，保存用户信息
          setUser(validUser);
          localStorage.setItem('user', JSON.stringify(validUser));
          return true;
        } else {
          // 用户不存在或密码错误
          return false;
        }
      })
      .catch(error => {
        console.error('登录验证失败:', error);
        return false;
      });
  };

  const register = (username, email, password) => {
    return registerUser({
      name: username,
      email: email,
      password: password
    })
      .then(result => {
        if (result.success) {
          // 注册成功
          return true;
        } else {
          // 注册失败（如用户名已存在）
          return false;
        }
      })
      .catch(error => {
        console.error('注册失败:', error);
        return false;
      });
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('user');
  };

  // 添加更新用户信息的方法
  const updateUser = (updatedUserInfo) => {
    const updatedUser = { ...user, ...updatedUserInfo };
    setUser(updatedUser);
    localStorage.setItem('user', JSON.stringify(updatedUser));
    
    // 同时更新用户特定的存储
    if (user && user.name) {
      // 从localStorage获取所有用户
      const storedUsers = JSON.parse(localStorage.getItem('users')) || [];
      const userIndex = storedUsers.findIndex(u => u.name === user.name);
      
      if (userIndex !== -1) {
        storedUsers[userIndex] = updatedUser;
        localStorage.setItem('users', JSON.stringify(storedUsers));
      }
    }
  };

  const value = {
    user,
    login,
    register,
    logout,
    updateUser // 添加更新用户信息的方法
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export { AuthContext };